import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Flex, FlexItem, Form, FormGroup, Input, Button, Box } from '@bigcommerce/big-design';

export default function Login({ setToken }) {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [errors, setErrors] = useState();

  const handleSubmit = async(e) => {
    e.preventDefault();
    // get our Product Data
    let login = await axios.post('/api/user/login', { username, password }).then(resp=>resp.data);
    if(login.token) { console.log(login.token); setToken(login); }
    else { setErrors(login.error); }
  }

  return (
    <div>
      <Box padding="medium">
        <Flex
          alignContent="center"
          alignItems="center"
          flexDirection="row"
          justifyContent="center"
          flexWrap="wrap"
        >
          <FlexItem alignSelf="center" flexBasis="50%" flexGrow={0}>
            <h1 className="center">Login</h1>
            { errors ? <p className="error center">{errors}</p> : null }
            <Form fullWidth="true" onSubmit={handleSubmit}>
              <FormGroup>
                <Input
                  name="username"
                  placeholder="Username"
                  type="text"
                  onChange={e => setUsername(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  name="password"
                  placeholder="Password"
                  type="password"
                  onChange={e => setPassword(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Button variant="primary">Submit</Button>
              </FormGroup>
            </Form>
          </FlexItem>
        </Flex>
      </Box>
    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};
